import { createSelector } from 'reselect'
import rolesList from 'const/rolesList'

export const getUserRoles = (state, props) => {
  return state.kanbo.userRoles
}

export const getAllUsersRolesConfig = (state, props) => state.kanbo.config.allUsersRoles

export default (userIdSelector) => createSelector(
  [
    userIdSelector,
    getUserRoles,
    getAllUsersRolesConfig,
  ],
  (
    userId,
    userRoles,
    allUsersRolesConfig,
  ) =>
    rolesList.reduce((acc, role) => {
      acc[role.id] =
        allUsersRolesConfig.includes(role.id) ||
        (
          userRoles[userId] && userRoles[userId].includes(role.id)
        )

      return acc
    }, {})
)
